export default "__VITE_ASSET__DrrenFqh__"